import type { Components, Theme } from '@mui/material/styles';

import palette from '@/theme/palette.ts';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    tag: true;
    'talent-state': true;
  }
}

const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ theme: { spacing, typography } }) => ({
      variants: [
        {
          props: { variant: 'tag', color: 'default' },
          style: {
            height: 'auto',
            borderRadius: spacing(0.5),
            padding: spacing(0.5, 1),
            backgroundColor: palette.primary[100],
            fontSize: spacing(1.5),
            fontWeight: 400,
            lineHeight: spacing(2),
            letterSpacing: 0.25
          }
        },
        {
          props: { variant: 'talent-state' },
          style: {
            ...typography.body2,
            fontWeight: typography.fontWeightMedium,
            color: palette.text.primary,
            background: 'unset',

            '& .MuiChip-icon': {
              margin: 0
            },

            '& .MuiChip-label': {
              padding: 0,
              marginLeft: spacing(0.5)
            }
          }
        },
        {
          props: { variant: 'talent-state', color: 'error' },
          style: {
            color: palette.error.main
          }
        },
        {
          props: { variant: 'talent-state', color: 'success' },
          style: { color: palette.green.main }
        }
      ]
    }),
    label: {
      variants: [
        {
          props: { variant: 'tag', color: 'default' },
          style: { padding: 0 }
        }
      ]
    }
  }
};

export default MuiChip;
